import User from './User'
import Menu from './Menu'
import UserTypeGroup from './UserTypeGroup'
import Privacy from './Privacy'
import PrivacyCheck from './PrivacyCheck'
import Running from './Running'
import Token from './Token'
import News from './News'
import ReportRun from './ReportRun'

export default {
  User,
  Menu,
  UserTypeGroup,
  Privacy,
  PrivacyCheck,
  Running,
  Token,
  News,
  ReportRun
}



// WEBPACK FOOTER //
// ./src/components/System/index.js